import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';

export default function Login() {
  const navigate = useNavigate();
  const { innerWidth: width, innerHeight: height } = window;
  const [empId, setEmpId]           = useState('');
  const [password, setPassword]     = useState('');
  const submit = async (e) => {
    { e.preventDefault();}
      
    const data = {
      emp_id    : empId,
      password  : password,
    }
    axios.post('employee/login', data)
    .then((response) => {
        // console.log(response);
        let data = response.data;
        if(data.response.status == 200){
          localStorage.setItem('token',response.data.data.token);
          setEmpId('');
          setPassword('');
          // navigate("/home");
          window.location.replace('gretings');
        }else{
          alert(data.response.message);
          setPassword('');
        }
        
        // window.location.assign('/');
    })
    .catch((error) => {
        console.log(error);
    });
    
  }
  return (
    <>
      <div style={{ backgroundColor : '#dc3545',width : width }}>
        <div style={{height: '100%',display: 'flex',alignContent: 'center',justifyContent: 'center',alignItems: 'center',flexDirection: 'column'}}>
          <img src='https://hrm.thephfactor.com.bd/storage/settings/theme/692732733.jpg' style={{ width : width * .7, padding : '30px'}}/>
        </div>
      </div>
      <div className='container mt-5'>
        <div className='row'>
          <div className='col-12'>
            <div className='py-2'>
              <input type="text" className='form-control' placeholder='employee ID' onChange={(e) => { setEmpId(e.target.value)}}
            value={empId} />
            </div>
            <div className='py-2'>
              <input type="password" className='form-control' placeholder='employee Password'  onChange={(e) => setPassword(e.target.value)}
            value={password}/>
            </div>
            <div className='py-2 mt-3'>
              <button className='btn btn-danger w-100' onClick={submit}> <i className='fas fa-login'></i>Login </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
